import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import '../css/workshop.css';
import CTA from '../components/CTA';
import SEO from '../components/SEO';
import WorkshopCard from '../components/Workshop/WorkshopCard';
import FeaturedCard from '../components/Workshop/FeaturedCard';

// Prismic
import Prismic from 'prismic-javascript';
import { Client, linkResolver } from '../prismic-configurations';

function Workshop({ history }) {
  const [doc, setDocData] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'workshop')
      );
      if (response) {
        setDocData(response.results);
      }
    };
    fetchData();
  }, []);

  const featured = doc ? doc.filter((i) => i.data.featured === true)[0] : {};
  const data = doc ? doc.filter((i) => !i.data.featured) : [];

  // Sort by date descending
  data.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(b.data.end_date) - new Date(a.data.end_date);
  });

  return (
    <>
      <div id="workshop">
        <SEO
          title={`WE3 Academy | Workshops`}
          description="We host training workshops, webinars, and networking events for tech enthusiasts, designers, social media enthusiasts, and entrepreneurs to share our knowledge and connect with people and encourage others to do so."
          keywords="WE3 Academy, WE3, workshops, workshop, events, event, networking events, career events, web development workshop, coding workshops, programming workshops, social media training, social media workshop, digital marketing workshop, training events, training event, training workshop, training workshops, seminar, seminars, networking seminars, social media seminars, programming seminars, webinars, webinar, social media webinar, events near me, events near me today, social media workshops this week, social media workshops near me, coding workshops near me, coding workshops this week, career events near me, career event, events today"
          link="/workshop"
        >
          <script type="application/ld+json">
            {`
              {
                "@context" : "http://schema.org",
                "@type" : "WebPage",
                "name" : "Workshops",
                "description" : "We host training workshops, webinars, and networking events for tech enthusiasts, designers, social media enthusiasts, and entrepreneurs to share our knowledge and connect with people and encourage others to do so.",
                "url" : "https://we3academy.com/workshop"
              }
          `}
          </script>
        </SEO>
        <ScrollToTop />

        <div id="workshop-container">
          <div className="workshop-header">
            <h1>Join Us For Online Workshops</h1>
            <p>
              We conduct workshops about coding, web development, social media
              marketing, product development and career development
            </p>
          </div>
          {featured?.data && (
            <FeaturedCard
              data={featured.data}
              tags={featured.tags}
              onClick={() => {
                history.push(linkResolver(featured));
              }}
            />
          )}

          <h2 className="center other">Other Events</h2>
          <div className="workshop-cards-container">
            {data.map((i) => (
              <WorkshopCard
                key={i.uid}
                uid={i.uid}
                data={i.data}
                tags={i.tags}
              />
            ))}
          </div>
        </div>

        <CTA styleType="style8" />
      </div>
    </>
  );
}

export default Workshop;
